import styled from 'styled-components';

export const Container = styled.div`
  padding: 32px;
  display: flex;
  flex-direction: column;

  p {
    margin: 1em 0 0.5em;
  }

  .spacer {
    height: 35px;
  }
`;

export const FeesWrapper = styled.p`
  margin: 1.5em 0;
`;
